import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// import {
//   Accordion,
//   AccordionItem,
//   AccordionItemHeading,
//   AccordionItemButton,
//   AccordionItemPanel,
// } from 'react-accessible-accordion';

import {
  Accordion,
  Disclosure,
  DisclosureTitle,
  DisclosurePanel,
} from "@adobe/react-spectrum";

import apiFetch from "../utils/_apiFetch";

const AccordionContainer = ({ dataUrl }) => {
  const [data, setData] = useState({
    slots: [],
  });

  useEffect(() => {
    const fetches = [
      apiFetch({
        url: dataUrl,
        method: "GET",
      }),
    ];
    Promise.all(fetches).then(([searchResults]) => {
      setData({ slots: searchResults });
    });
  }, []);

  const { slots } = data;

  const createMarkup = (text) => {
    return { __html: text };
  };

  const constructComponentsTree = (slot, defaultExpanded = false) => {
    const { id, title, text, children } = slot;
    const hasChildren = children && children.length;
    let childrenList = "";

    if (hasChildren) {
      childrenList = children.map((subSlot) => {
        if (subSlot.children && subSlot.children.length) {
          return <Accordion>{constructComponentsTree(subSlot)}</Accordion>;
        } else {
          return (
            <div className="accordion-leaf" key={subSlot.id}>
              {subSlot.url ? (
                <a href={subSlot.url} title={subSlot.title}>
                  {subSlot.title}
                  <i className="fas fa-chevron-right" />
                </a>
              ) : (
                <span>{subSlot.title}</span>
              )}
            </div>
          );
        }
      });
    }

    return (
      <Disclosure id={id} key={id} UNSAFE_className="accordion-rt-item">
        <DisclosureTitle UNSAFE_className="accordion-rt-heading">
          {title}
        </DisclosureTitle>
        <DisclosurePanel UNSAFE_className="accordion-rt-content">
          {text ? <div dangerouslySetInnerHTML={createMarkup(text)} /> : ""}
          {childrenList}
        </DisclosurePanel>
      </Disclosure>
    );
  };

  return slots.length ? (
    <div className="accordion">
      <Accordion
        allowsMultipleExpanded
        // defaultExpandedKeys={[slots[0].id]}
        UNSAFE_className="accordion-rt"
      >
        {slots.map((slot, i) => constructComponentsTree(slot, i == 0))}
      </Accordion>
    </div>
  ) : (
    ""
  );
};

AccordionContainer.propTypes = {
  dataUrl: PropTypes.string.isRequired,
};

export default AccordionContainer;
